export {CountdownComponent} from './CountdownComponent';
export type {CountdownComponentDefinition} from './CountdownComponent';
export {
  defaultFieldData,
  schema,
  uiSchema,
  ComponentDefinition,
  DefaultUnitLabels,
} from './CountdownDefinition';
export type {
  SchemaType,
  SchemaType as CountdownProps,
} from './CountdownDefinition';
export {CountdownPreviewComponent} from './CountdownPreviewComponent';

import {Registry} from '@backstage-components/base';
import {CountdownModule} from './CountdownModule';
import {ComponentDefinition} from './CountdownDefinition';
Registry.register(ComponentDefinition, CountdownModule);
